module.exports = __webpack_public_path__ + "/images/ico-color-hucha-pig.e797907.svg";